import React, { cloneElement, FC } from 'react';
import { ActionPromptType } from '../../hooks/prompts';
import { usePromptsContext } from '../../providers/prompts-context';
import { Highlight } from './Highlight';

interface IHighlightableProps {
    promptType: ActionPromptType;
    children: React.ReactElement;
    highlightClass?: string;
    highlightOffsetX?: string;
    highlightOffsetY?: string;
}

export const Highlightable: FC<IHighlightableProps> = ({ promptType, children, highlightClass, highlightOffsetX, highlightOffsetY }) => {
    const { completePrompt, hasPrompt } = usePromptsContext();
    const shouldHighlight = hasPrompt(promptType);

    const handleClick = (event: React.MouseEvent) => {
        if (shouldHighlight)
            completePrompt(promptType);

        if (children.props.onClick)
            children.props.onClick(event);
    };

    return cloneElement(children, {
        className: `${children.props.className || ''} ${shouldHighlight && highlightClass ? highlightClass : ''}`.trim(),
        style: {
            ...children.props.style,
            position: 'relative'
        },
        onClick: handleClick,
        children: (
        <>
            { children.props.children }
            { !highlightClass && <Highlight enabled={shouldHighlight} offsetX={highlightOffsetX} offsetY={highlightOffsetY} /> }
        </>
        )
    });
};
